module.exports = __webpack_public_path__ + "img/destroyer-robot-mask.861909ff.png";